import { UIAPIEndpoints } from '../../network/UIAPIEndpoints.ts';
import { UIAjaxWrapper } from '../../network/UIAjaxWrapper.ts';
import { showSimpleDialog } from '../showSimpleDialog.ts';
import { notificationController } from '../../EntryShared.ts';
import { LobbyImage } from '@colonist/types';
import { TimeUtils } from '@colonist/utils';
import { NotificationTypeEnum } from '../../../../../shared/NotificationTypes.ts';
import { UIUtilsEjsVariables } from '../../UIUtilsEjsVariables.ts';
import { ClientUserState } from '../../ClientUserState.ts';
import { navigateToPage } from '../../ui_utils/ClientUtils.ts';
export class UIServerNotificationController {
    static async displayAllPendingNotifications() {
        if (UIUtilsEjsVariables.isUserOnDiscord) return;
        if (UIUtilsEjsVariables.isUserOnMobileAppOrWeb) return;
        if (ClientUserState.userState == undefined) return;
        const notificationPanelContainer = document.getElementById('header_profile_notification_container');
        const isNotificationPanelVisible = notificationPanelContainer.classList.contains('hidden') == false;
        if (isNotificationPanelVisible) return;
        const res = await UIAjaxWrapper.getRequestHandler(UIAPIEndpoints.apiGetNotifications(), undefined);
        if (res == undefined) return;
        const notifications = res.json;
        for (const notification of notifications){
            if (this.isCornerPopup(notification)) {
                this.displayCornerPopup(notification);
            } else {
                this.displayViewPopup(notification);
            }
        }
    }
    static isCornerPopup(notification) {
        switch(notification.typeData.type){
            case NotificationTypeEnum.UserReportedWarning:
                return true;
            default:
                return false;
        }
    }
    static displayCornerPopup(notification) {
        const popupData = this.getCornerPopupData(notification);
        notificationController.showNotification(popupData.image, popupData.text, popupData.duration, undefined, this.markNotificationAsReadAction(notification.id));
    }
    static displayViewPopup(notification) {
        const popupData = this.getViewPopupData(notification);
        if (popupData == undefined) return;
        const markAsRead = this.markNotificationAsReadAction(notification.id);
        showSimpleDialog({
            title: popupData.title,
            body: popupData.body,
            onDismiss: ()=>void markAsRead(),
            ...popupData.confirmLabel != undefined ? {
                confirmLabel: popupData.confirmLabel
            } : {},
            ...popupData.checkAction != undefined ? {
                onConfirm: popupData.checkAction
            } : {}
        });
    }
    static getViewPopupData(notification) {
        switch(notification.typeData.type){
            case NotificationTypeEnum.UserReportedBanned:
                return {
                    title: {
                        key: 'strings:popups.notification.reportedUserBanned.title'
                    },
                    body: {
                        key: 'strings:popups.notification.reportedUserBanned.body'
                    }
                };
            case NotificationTypeEnum.UserReportedThankYou:
                return {
                    title: {
                        key: 'strings:popups.notification.reportedUserThankYou.title'
                    },
                    body: {
                        key: 'strings:popups.notification.reportedUserThankYou.body'
                    }
                };
            case NotificationTypeEnum.HolidaySale2023Expired:
                return {
                    title: {
                        key: 'strings:popups.notification.holidaySale2023Expired.title'
                    },
                    body: {
                        key: 'strings:popups.notification.holidaySale2023Expired.body'
                    }
                };
            case NotificationTypeEnum.TranslationHelp:
                return {
                    title: {
                        key: 'strings:popups.notification.translationHelp.title'
                    },
                    body: {
                        key: 'strings:popups.notification.translationHelp.body',
                        options: {
                            language: notification.typeData.language,
                            username: notification.typeData.username,
                            link: notification.typeData.link
                        }
                    }
                };
            case NotificationTypeEnum.GiftMembershipReceivedFromAdmin:
                return {
                    title: {
                        key: 'strings:popups.notification.giftMembershipReceived.title'
                    },
                    body: {
                        key: 'strings:popups.notification.giftMembershipReceived.body'
                    },
                    confirmLabel: {
                        key: 'strings:popups.notification.giftMembershipReceived.checkButton'
                    },
                    checkAction: ()=>navigateToPage('/store#gifted_memberships', true)
                };
            default:
                return undefined;
        }
    }
    static getCornerPopupData(notification) {
        switch(notification.typeData.type){
            case NotificationTypeEnum.UserReportedWarning:
                return {
                    image: LobbyImage.DangerIcon,
                    text: {
                        key: 'strings:popups.notification.reportedUserWarning'
                    },
                    duration: TimeUtils.SECONDS_IN_MINUTE * TimeUtils.MILLISECONDS
                };
            default:
                throw new Error('Unsupported notification type for displayCornerPopup');
        }
    }
    static markNotificationAsReadAction(notificationId, additionalRemoveAction) {
        return async ()=>{
            await UIAjaxWrapper.postRequestHandler(UIAPIEndpoints.apiMarkNotificationAsRead(notificationId), undefined, undefined);
            additionalRemoveAction === null || additionalRemoveAction === void 0 ? void 0 : additionalRemoveAction();
        };
    }
}
